import Vue from "vue";

export default {
  data() {
    return {
      deletePermission: false,
      updatePermission: true,
      publishPermission: false,
      rejectPermission: false,
      recallPermission: false,
      submitForApprovalPermission: false,
      cancelPermission: false,
    };
  },
  methods: {
    defineEntityProperties(entity) {
      let status = this.getEntityStatusForPermission(entity);
      return this.definePermissions(status);
    },

    getEntityStatusForPermission(entity) {
      if (entity.intentId !== 0 && entity.intents !== undefined && entity.intents !== null) {
        return entity.intents[0].status;
      } else {
        return "PUBLISHED";
      }
    },

    definePermissions(entityStatus) {
      switch (entityStatus) {
        case "DRAFT":
          this.submitForApprovalPermission = true;
          this.updatePermission = true;
          this.deletePermission = false;
          this.publishPermission = false;
          this.rejectPermission = false;
          this.recallPermission = false;
          this.cancelPermission = true;
          //TODO: Became DRAFT
          break;
        case "WAITING_APPROVAL":
          this.submitForApprovalPermission = false;
          this.updatePermission = false;
          this.deletePermission = false;
          this.publishPermission = true;
          this.rejectPermission = true;
          this.recallPermission = true;
          this.cancelPermission = false;
          //TODO: Became DRAFT
          break;
        case "PUBLISHED":
          this.submitForApprovalPermission = false;
          this.updatePermission = true;
          this.deletePermission = true;
          this.publishPermission = false;
          this.rejectPermission = false;
          this.recallPermission = false;
          this.cancelPermission = false;
          break;
        case "DELETED":
          this.submitForApprovalPermission = false;
          this.updatePermission = false;
          this.deletePermission = true;
          this.publishPermission = false;
          this.rejectPermission = false;
          this.recallPermission = false;
          this.cancelPermission = false;
          //TODO: Became DRAFT
          break;
      }
      return entityStatus;
    },

    getEntityStatus(entity) {
      if (!entity.intentId) return;
      if (entity.intentId !== 0) {
        return entity.intents[0].type + " | " + entity.intents[0].status;
      } else {
        return "PUBLISHED";
      }
    },

    tableRadioBtnTrClick() {
      $(".stationTable table tbody tr").click(function () {
        $(this).find("input:radio").prop("checked", true);
      });
    },

    resetRadioButtonAndPermissions() {
      this.publishPermission = false;
      this.rejectPermission = false;
      this.recallPermission = false;
      this.submitForApprovalPermission = false;
      this.updatePermission = false;
      this.deletePermission = false;
      this.cancelPermission = false;
    },
  },
};
